// api/userSettings.js
import axios from "./api.js";

export const getUserSettings = async () => {
  const response = await axios.get("/user-settings");
  return response.data;
};

export const updateUserSetting = async (settingKey, settingValue) => {
  const response = await axios.put("/user-settings", {
    setting_key: settingKey,
    setting_value: settingValue,
  });
  return response.data;
};

export const updateMultipleUserSettings = async (settings) => {
  const response = await axios.put("/user-settings/bulk", {
    settings,
  });
  return response.data;
};
